import config from './config';

/* eslint-disable */
export default {
  install(Vue, options) {
    includeIntercom();
  },

  async boot(memberId, userProperties = {}) {
    const intercomEnabled = config.get().intercomEnabled;
    const appId = config.get().intercomProdAppId;

    if (intercomEnabled) {
      window.Intercom('boot', {
        app_id: appId,
        user_id: memberId,
        ...userProperties,
        'hide_default_launcher': true,
      })
    }
  },
  show() {
    window.Intercom('show');
  },
  hide() {
    window.Intercom('hide');
  },
  hideLauncher() {
    window.Intercom('update', {
      'hide_default_launcher': true
    });
  },
  showLauncher() {
    window.Intercom('update', {
      'hide_default_launcher': false
    });
  },
  showNewMessage(prompt = '') {
    window.Intercom('showNewMessage', prompt);
  },
};

function includeIntercom() {
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function() {
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function() {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/APP_ID';
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}
